import React, { useEffect } from "react";
import { FormField } from "./FormField";
import styles from "./styles.module.scss";
import { useFormStore } from "src/store/dataEntryForm";
import { FieldGroupWithSelect } from "./FieldGroup";
import Calendar from "@assets/icons/calendar";
import { DollarSign } from "lucide-react";

interface SkuFormProps {
  formId: string;
  onSubmit?: () => void;
}

const priceOptions = [
  { value: "netProceeds", label: "Net Proceeds" },
  { value: "contributionProfit", label: "Contribution Profit" },
];

const amazonFeeOptions = [
  { value: "baseFulfillmentFee", label: "Base Fulfillment Fee" },
  { value: "fbaFulfillmentFees", label: "FBA Fulfillment Fees" },
  { value: "refundAdministrationFee", label: "Refund Administration Fee" },
  { value: "referralFee", label: "Referral Fee" },
  {
    value: "monthlyInventoryStorageFee",
    label: "Monthly Inventory Storage Fee",
  },
];

const unitsReturnedOptions = [
  { value: "netSales", label: "Net Sales" },
  { value: "netProceeds", label: "Net Proceeds" },
  { value: "netMargin", label: "Net Margin" },
];

export const SkuForm: React.FC<SkuFormProps> = ({ formId, onSubmit }) => {
  const { initializeForm, resetForm } = useFormStore();

  useEffect(() => {
    initializeForm(formId, {
      date: "",
      asin: "",
      cogs: "",
      priceValue: "",
      unitsSold: "",

      price1Type: "netProceeds",
      price1Value: "",

      amazonFee1Type: "baseFulfillmentFee",
      amazonFee1Value: "",

      unitsReturned1Type: "netSales",
      unitsReturned1Value: "",
    });

    return () => resetForm(formId);
  }, [formId, initializeForm, resetForm]);

  return (
    <div className={styles.addSkuContainer}>
      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="date"
          label="Date"
          placeholder="Select Date"
          size="small"
          type="date"
          icon={<Calendar />}
        />
        <FormField
          formId={formId}
          fieldName="asin"
          label="ASIN"
          placeholder=""
          size="small"
        />
      </div>

      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="cogs"
          label="COGS, $"
          placeholder=""
          type="number"
          size="small"
          icon={<DollarSign size={20} color="#7C7C78" />}
        />
        <FormField
          formId={formId}
          fieldName="unitsSold"
          label="Units sold, items"
          placeholder=""
          type="number"
          size="small"
        />
      </div>

      <div className={styles.row}>
        <FormField
          formId={formId}
          fieldName="priceValue"
          label="PRICE"
          type="number"
          size="small"
          icon={<DollarSign size={20} color="#7C7C78" />}
        />
      </div>

      <FieldGroupWithSelect
        formId={formId}
        fieldGroupName="price"
        label="PRICE"
        valueLabel="Value, $"
        options={priceOptions}
        maxGroups={2}
        defaultType="netProceeds"
        valueIcon={<DollarSign size={20} color="#7C7C78" />}
      />

      <FieldGroupWithSelect
        formId={formId}
        fieldGroupName="amazonFee"
        label="AMAZON FEE"
        valueLabel="Value, $"
        options={amazonFeeOptions}
        maxGroups={3}
        defaultType="baseFulfillmentFee"
        valueIcon={<DollarSign size={20} color="#7C7C78" />}
      />

      <FieldGroupWithSelect
        formId={formId}
        fieldGroupName="unitsReturned"
        label="UNITS RETURNED"
        valueLabel="Value, $"
        options={unitsReturnedOptions}
        maxGroups={2}
        defaultType="netSales"
        valueIcon={<DollarSign size={20} color="#7C7C78" />}
      />
    </div>
  );
};
